import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import EntityMemberSchema, { EntityMemberJSON } from "_shared/entity-members/entity-member-schema";
import z from "zod";

export const entityMemberApi = api.injectEndpoints({
  endpoints: (build) => ({
    // #region Get
    getEntityMembersByEntityId: build.query<EntityMemberJSON[], { legalEntityId: string }>({
      query: ({ legalEntityId }) => `/legal-entities/${legalEntityId}/members/`,
      rawResponseSchema: z.array(EntityMemberSchema.EntityMemberJSONZ),
      onSchemaFailure: logSchemaFailure,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ userId }) => ({ type: "EntityMember" as const, id: userId })),
              { type: "EntityMember" as const, id: "LIST" },
            ]
          : [{ type: "EntityMember" as const, id: "LIST" }],
    }),
    // #endregion
  }),
});

export const { useGetEntityMembersByEntityIdQuery } = entityMemberApi;
